import angular from 'angular';
import { tabsComponent } from './tabsComponent';
import { tabComponent } from './tabComponent';

angular.module('sh.tabs', []).component('shTabs', tabsComponent()).component('shTab', tabComponent());
